import { animate, state, style, transition, trigger } from '@angular/animations';

export const fadeInAnimation = trigger('fadeInAnimation', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('300ms', style({ opacity: 1 })),
  ]),
]);

export const fadeOutAnimation = trigger('fadeOutAnimation', [
  transition(':leave', [animate('300ms', style({ opacity: 0 }))]),
]);

export const slideOutAnimation = trigger('slideOutAnimation', [
  transition(':leave', [
    animate('500ms ease-out', style({ transform: 'translateX(100%)' })),
  ]),
]);

export const slideInAnimation = trigger('slideInAnimation', [
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    animate('500ms ease-out', style({ transform: 'translateX(0%)' })),
  ]),
]);

export const slideDownAnimation = trigger('slideDownAnimation', [
  transition(':leave', [
    style({ transform: 'translateY(-100%)' }),
    animate('500ms ease-out', style({ transform: 'translateY(0%)' })),
  ]),
]);

export const slideUpAnimation = trigger('slideUpAnimation', [
  transition(':enter', [
    style({ transform: 'translateY(100%)' }),
    animate('500ms ease-out', style({ transform: 'translateY(0%)' })),
  ]),
]);

export const rollUpAnimation = trigger('rollUpAnimation', [
  transition(':enter', [
    style({ transform: 'translateY(100%)' }),
    animate('500ms ease-out', style({ transform: 'translateY(0%)' })),
  ]),
  transition(':leave', [
    style({ transform: 'translateY(0%)' }),
    animate('500ms ease-out', style({ transform: 'translateY(-100%)' })),
  ]),
]);

export const rollDownAnimation = trigger('rollDownAnimation', [
  transition(':leave', [
    style({ transform: 'translateY(0%)' }),
    animate('500ms ease-out', style({ transform: 'translateY(100%)' })),
  ]),
]);

export const shrinkAnimation = trigger('shrinkAnimation', [
  transition(':leave', [
    style({ height: '*', opacity: 1, transform: 'scale(1.0)' }),
    animate(
      '300ms ease-out',
      style({ height: 0, opacity: 0, transform: 'scale(0.8)' }),
    ),
  ]),
]);

export const scaleInAnimation = trigger('scaleInAnimation', [
  transition(':enter', [
    style({ transform: 'scale(0)' }),
    animate('300ms ease-out', style({ transform: 'scale(1)' })),
  ]),
]);

export const fadeOutBackgroundAnimation = trigger('fadeOutBackgroundAnimation', [
  state('in', style({ backgroundColor: '#daead7', opacity: 1 })),
  transition(':enter', [
    style({ backgroundColor: '#daead7', opacity: 0 }),
    animate('1s', style({ backgroundColor: '#daead7', opacity: 1 })),
    animate('1s', style({ backgroundColor: 'white', opacity: 1 })),
  ]),
]);
